// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609032238/js/" + chunkId + "." + {"44":"6058f654","225":"15d67163","481":"f08b8012","486":"1c461364","770":"48d2e258"}[chunkId] + ".0.5429540877966442.chunk.js";
};